"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.app = void 0;
exports.app = function (axios) {
    return {
        getApps: function (request) {
            return axios.get('/apps', request);
        },
        getAppSummary: function (request) {
            return axios.get('/apps/summary', request);
        },
        getAppsInstalled: function (request) {
            return axios.get('/apps/installed', request);
        },
        postApps: function (request) {
            return axios.post('/apps', request.data);
        },
        postAppsExternalLinkApp: function (request) {
            return axios.post('/apps/external-link-app', request.data);
        },
        postAppsAppNoInstalled: function (request) {
            var appNo = request.pathParams.appNo;
            return axios.post("/apps/" + appNo + "/installed", request.data);
        },
        getAppsWebhookTypes: function () {
            return axios.get('/apps/webhook-types');
        },
        getAppsAppNo: function (request) {
            var appNo = request.pathParams.appNo;
            return axios.get("/apps/" + appNo);
        },
        putAppsAppNoDevelop: function (request) {
            var appNo = request.pathParams.appNo;
            return axios.put("/apps/" + appNo + "/develop", request.data);
        },
        putAppsAppNoSales: function (request) {
            var appNo = request.pathParams.appNo;
            return axios.put("/apps/" + appNo + "/sales", request.data);
        },
        getAppsAppNoMalls: function (request) {
            var appNo = request.pathParams.appNo;
            return axios.get("/apps/" + appNo + "/malls");
        },
        getAppsAppNoRejected: function (request) {
            var appNo = request.pathParams.appNo;
            return axios.get("/apps/" + appNo + "/rejected");
        },
        putAppsAppNoSaleStatus: function (request) {
            var appNo = request.pathParams.appNo;
            return axios.put("/apps/" + appNo + "/sale-status", request.data);
        },
    };
};
